import { Component, OnInit } from '@angular/core';
import { RestService } from '../rest.service';
import { UserService } from '../user.service';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es';
import { ExcelexportService } from '../excelexport.service';

@Component({
  selector: 'app-fact-dif',
  templateUrl: './fact-dif.component.html',
  styleUrls: ['./fact-dif.component.scss']
})
export class FactDifComponent implements OnInit {

  rangos: any[] = [];
  data: any[] = [];

  dateSimple;
  dateTime: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.dateSimple = dateStr;
      this.ObtenerFechaComparacion();
    }
  };

  dateComparativa;
  dateTime2: FlatpickrOptions = {
    enableTime: false,
    dateFormat: 'Y-m-d',
    locale: Spanish,
    onChange: (selectedDates, dateStr, instance) => {
      this.dateComparativa = dateStr;
    }
  };

  rango_selected;

  constructor(
    private rest: RestService,
    private excel: ExcelexportService,
    public user: UserService ) {
      this.GetRangos();
      this.GetDefault();
    }

  ngOnInit() {}

  GetRangos() {
    this.rest.GetRangos().subscribe((data) => {
      this.rangos = data['data'];
    });
  }

  exportXlsx() {

    const promise = new Promise( (resolve) => {
      let general = [];
      let comparativa = [];
      let diferencia = [];

      for (let index = 0; index < this.data.length; index++) {
        general[index] = {
          'concepto' : this.data[index]['concepto'],
          'costa' : this.data[index]['costa']['general'],
          'gorrion' : this.data[index]['gorrion']['general'],
          'navas' : this.data[index]['navas']['general'],
          'riscal' : this.data[index]['riscal']['general'],
        };

        comparativa[index] = {
          'concepto' : this.data[index]['concepto'],
          'costa' : this.data[index]['costa']['comparativa'],
          'gorrion' : this.data[index]['gorrion']['comparativa'],
          'navas' : this.data[index]['navas']['comparativa'],
          'riscal' : this.data[index]['riscal']['comparativa'],
        };

        diferencia[index] = {
          'concepto' : this.data[index]['concepto'],
          'costa' : this.data[index]['costa']['diferencia'],
          'gorrion' : this.data[index]['gorrion']['diferencia'],
          'navas' : this.data[index]['navas']['diferencia'],
          'riscal' : this.data[index]['riscal']['diferencia'],
        };
      }

      resolve([general, comparativa, diferencia]);
    });

    promise.then( (arrayResult: any[]) => {
      this.excel.fact2Export(
        arrayResult[0], arrayResult[1], arrayResult[2],'ALZIS_' + this.dateSimple + 'VS' + this.dateComparativa);
    });

  }

  ObtenerFechaComparacion() {
    this.rest.Getfecha_comparacion(this.user.formatDate(this.dateSimple))
    .subscribe( (data) => {
      this.dateComparativa = data['data'][0]['fecha'];
    });
  }

  parseInt(myAcc) {
    let intValue = parseInt(myAcc);

    if (intValue >= 0) {
        return true;
    } else {
        return false;
    }
}

  GetDefault() {
    this.rest.GetDefault().subscribe( (data) => {
      this.rango_selected = data['data'].rango;

      this.dateSimple = {
        year: new Date(data['data'].general).getFullYear(),
        month: new Date(data['data'].general).getMonth() + 1 ,
        day: new Date(data['data'].general).getDate()
      };

      this.dateComparativa = {
        year: new Date(data['data'].comparacion).getFullYear(),
        month: new Date(data['data'].comparacion).getMonth() + 1 ,
        day: new Date(data['data'].comparacion).getDate()
      };

    });
  }

  Event(event) {
    console.log('Event' , event);
  }

  GetData() {
    this.rest.GetData(this.rango_selected.id, this.user.formatDate(this.dateSimple), this.user.formatDate(this.dateComparativa) )
    .subscribe(
      (data) => {
        this.data = data['data'];
      });
  }


}
